import { Styled, ButtonProps } from './';

const Button = ({
  variant = 'primary',
  fullWidth,
  disabled,
  loading,
  children,
  onClick,
  onMouseEnter,
  size = 'sm',
  width,
  className = '',
  testId = 'button',
}: ButtonProps) => (
  <Styled.Button
    variant={variant}
    customDisabled={disabled}
    loading={loading?.toString()}
    fullWidth={fullWidth}
    onClick={onClick}
    onMouseEnter={onMouseEnter}
    size={size}
    width={width}
    disabled={disabled}
  >
    {loading ? (
      <Styled.ButtonBody
        isLoading={loading.toString()}
        className={className}
        data-testid={testId}
      >
        <Styled.ButtonLoading />
        <Styled.ButtonTitle>{children}</Styled.ButtonTitle>
      </Styled.ButtonBody>
    ) : (
      <Styled.ButtonBody data-testid={testId} className={className}>
        {children}
      </Styled.ButtonBody>
    )}
  </Styled.Button>
);

export default Button;
